// extracted by mini-css-extract-plugin
module.exports = {"TemperatureData":"TemperatureData_TemperatureData__1qz4z","ReconnectBtn":"TemperatureData_ReconnectBtn__1Mpau"};